import React, { useEffect, useState } from 'react';
import './projection-planning-list.scss';
import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  AggregateColumnDirective,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  ColumnChooser,
  Reorder,
  DialogEditEventArgs,
} from '@syncfusion/ej2-react-grids';
import moment from 'moment'
import HardDelete from '../hard-delete/hard-delete';
import securityService from '../security/security.service';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import SecurityService from '../security/security.service';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import AuditTableInput from '../audit-table/audit-table';
import projectionPlanningService from './projection-planning.service';
var selectedRows = [];

const OrderDetails = ({ ProjectionPlanningUpperData }) => {
  
  if (ProjectionPlanningUpperData.length > 0) {
    return (
      <div>
        <div className='row'>
          <div className='col'>
            <label>Vendor Name:</label>
          </div>
          <div className='col'>
            <label>{ProjectionPlanningUpperData[0].CompanyName}</label>
          </div>
        </div>

        <div className='row'>
          <div className='col'>
            <label>Customer Name:</label>
          </div>
          <div className='col'>
            <label>{ProjectionPlanningUpperData[0].CustomerName}</label>
          </div>
        </div>

        <div className='row'>
          <div className='col'>
            <label>Order Meters:</label>
          </div>
          <div className='col'>
            <label>{Number(ProjectionPlanningUpperData[0].OrderQuantity).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</label>
          </div>
        </div>

        <div className='row'>
          <div className='col'>
            <label>Projected Meters:</label>
          </div>
          <div className='col'>
            <label>{Number(ProjectionPlanningUpperData[0].TotalProjectionPlanningQuantity).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</label>
          </div>
        </div>

        <div className='row'>
          <div className='col'>
            <label>Balance Projection Meters:</label>
          </div>
          <div className='col'>
            <label>{Number(ProjectionPlanningUpperData[0].BalanceProjectionPlanningQuantity).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</label>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>Loading...</div>
      );
    }
  };
  
  let ProjectionGrid: Grid;
  let belowProjectionGrid: Grid;

export default function FabricContractDeliveryScheduleList(props) {
  const [showDialogs, setShowDialogs] = useState();
  const [deletingProps, setDeletingProps] = useState();
  
  const [belowProjectionDataSource, setBelowProjectionDataSource] = useState([]);
  
  const [projectionDataSource, setProjectionDataSource] = useState([]);
  
  const [projectionPlanningUpperData, setProjectionPlanningUpperData] = useState([]);

  useEffect(() => {
    getProjectionPlanningUpperData(props.FabricContractID);
    getBelowProjectionData()
  }, []);
// Api Functions
const getProjectionPlanningUpperData = async (id)=>{
  const response = await projectionPlanningService.getProjectionPlanningUpperData(id);
  console.log(response.data.recordset)
  setProjectionPlanningUpperData(response.data.recordset)
  getProjectionDataSource(response.data.recordset[0].CompanyIDCustomer , response.data.recordset[0].FabricQualityID);
}

const getProjectionDataSource = async (CompanyID,FabricQualityID) => {
  console.log("Fabric Delivery Schedule", props)
  if(props?.FabricContractID) {
  projectionPlanningService.getProjection(CompanyID , FabricQualityID).then((response) => {
      console.log(response);
      let data = response.data.recordset.map(res=>{
        return{
          ...res,
          ProjectionPlanningDate:'',
          ProjectionPlanningQuantity:0,
          FinalBalanceToProjectMeters:res.BalanceProjectionPlanningQuantity,
        }
      })
      setProjectionDataSource(data);
    })
    .catch((e) => {
      console.log(e);
    });
  }
};

const getBelowProjectionData = async () => {
  if(props?.FabricContractID) {
  projectionPlanningService.getBelowProjection(props?.FabricContractID).then((response) => {
      console.log(response);
      setBelowProjectionDataSource(response.data.recordset);
    })
    .catch((e) => {
      console.log(e);
    });
  }
  };

// ************************************************
// ************************************************
// ************* GRID PARAMETERS START ************
// ************************************************
// ************************************************
  
  const toolbarOptions: ToolbarItems[] = ['Edit','Update','Cancel'];
  
  const belowtoolbarOptions: ToolbarItems[] = ['Delete'];
  
  const editSettings: EditSettingsModel = {
      allowEditing: SecurityService.canUserAccess('FabricPurchaseContractDeliveryScheduleEdit'),
      allowAdding:false,
      allowDeleting: false,
      mode: 'Normal',
      showDeleteConfirmDialog: true,
    };
  
  const beloweditSettings: EditSettingsModel = {
      allowEditing: false,
      allowAdding:false,
      allowDeleting: SecurityService.canUserAccess('FabricPurchaseContractDeliveryScheduleEdit'),
      mode: 'Normal',
      };
  
  const filterOptions: FilterSettingsModel = {type: 'Excel'};
  
  const belowFilterOptions: FilterSettingsModel = {type: 'Excel', columns: [{field: "IsDeleted",operator: "notequal",value: "True",}],};
  
  const sortingOptions: SortSettingsModel = { columns: [{ field: 'ProjectionID', direction: 'Ascending' }]}
  
  const belowsortingOptions: SortSettingsModel = {columns: [{ field: 'FabricContractProjectionPlanningID', direction: 'Descending' }]}
  
// ************************************************
// ************************************************
// ************* GRID PARAMETERS END **************
// ************************************************
// ************************************************
  
  const databound = () =>{if (belowProjectionGrid) {belowProjectionGrid.autoFitColumns();}}

  const actionComplete = (args: DialogEditEventArgs) => {
    if (args.requestType === 'save' && args.action === 'edit') { 
      console.log(args)
      const data = {
        FabricContractID:	props.FabricContractID,
        ProjectionID: args.data.ProjectionID,	
        ProjectionPlanningDate:	moment(args.data.ProjectionPlanningDate).format('YYYY-MM-DD'),
        ProjectionPlanningQuantity:args.data.ProjectionPlanningQuantity,
        UserID: userId,
      };
      console.log('data : ', data);
      projectionPlanningService.insert(data)
        .then((response) => {
          console.log(data);
         const tempData = [...projectionDataSource]
         tempData[args.rowIndex] = {
          ...projectionDataSource[args.rowIndex],
          ProjectionPlanningDate:	moment(args.data.ProjectionPlanningDate).format('YYYY-MM-DD'),
          ProjectionPlanningQuantity:args.data.ProjectionPlanningQuantity,
          FinalBalanceToProjectMeters:args.data.BalanceProjectionPlanningQuantity - args.data.ProjectionPlanningQuantity,
          TotalProjectionPlannedQuantity:args.data.TotalProjectionPlannedQuantity + args.data.ProjectionPlanningQuantity,
          BalanceProjectionPlanningQuantity:args.data.BalanceProjectionPlanningQuantity - args.data.ProjectionPlanningQuantity
         }
         console.log(tempData)
         setProjectionDataSource(tempData)

          let AddData = {
            ProjectionPlanningDate:	moment(args.data.ProjectionPlanningDate).format('YYYY-MM-DD'),
            ProjectionPlanningQuantity:args.data.ProjectionPlanningQuantity
            }
          AuditTableInput.auditAdd(`FabricContract - ProjectionPlanning`,`FabricContract_ProjectionPlanning`,`FabricContractProjectionPlanningID`,AddData)
          let nextRowIndex = args.rowIndex + 1;
          if (ProjectionGrid.getRows().length > nextRowIndex) {
            setTimeout(() => {
              ProjectionGrid.selectRow(nextRowIndex);
                ProjectionGrid.startEdit();
            }, 500);
          } else {
            ProjectionGrid.closeEdit();
          }
          getBelowProjectionData()
        })
        .catch((e) => {
          console.log(e);
        });
    }
    };


    const toolbarClick = (args: ClickEventArgs) => {
      console.log(args)
      if (belowProjectionGrid && args.item.properties.id === "belowProjectionGrid_delete") {
        console.log('toolbar Delete');
        if (belowProjectionGrid.selectedRowIndex === -1) {
          let obj={
            RowID:undefined,
            SelectedRow:false,
          }
          setDeletingProps(obj)
          setShowDialogs(true)
          }else {
          console.log('delete: ', belowProjectionGrid.getSelectedRecords()[0]?.FabricContractDeliveryScheduleID)
          let obj={
            TableName:`FabricContract_ProjectionPlanning`,
            ColumnName:`FabricContractProjectionPlanningID`,
            RowID:belowProjectionGrid.getSelectedRecords()[0]?.FabricContractProjectionPlanningID,
            SelectedRow:true,
            DeleteSecurity:`CostingDelete`,
            UserID:userId,
            SelectedRowData:{
              ProjectionPlanningDate:moment(belowProjectionGrid.getSelectedRecords()[0].ProjectionPlanningDate).format('YYYY-MM-DD'),
              ProjectionPlanningQuantity:belowProjectionGrid.getSelectedRecords()[0].ProjectionPlanningQuantity,
              }
            }
            setDeletingProps(obj)
            setShowDialogs(true)
        }}} 
    
  
  const userId = securityService.getLoggedInUserId();
  const formatOptions = { type: 'date', format: 'dd/MM/yy' }
  
  const footerSum = (e: any) => {
    return <span> Sum: {e.Sum.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</span>;
  };
    const projectionGridColumns = ()=>{
      return(
        <ColumnsDirective>
        <ColumnDirective headerText= 'ID' field= 'ProjectionID' headerTextAlign='center' textAlign='left' width='90' allowEditing={false}/>
        <ColumnDirective headerText= 'From Date' field= 'FromDate' headerTextAlign='center' textAlign='right' width='120' allowEditing={false} type='date' format={formatOptions}editType='datepickeredit'/>
        <ColumnDirective headerText= 'To Date' field= 'ToDate' headerTextAlign='center' textAlign='right' width='120' allowEditing={false} type='date' format={formatOptions} editType='datepickeredit'/>
        <ColumnDirective headerText= 'Required Meters' field= 'ProjectionQuantity' headerTextAlign='center' textAlign='right' width='150' allowEditing={false}   editType='numericedit' format={'N0'} edit={{ params:{ showSpinButton:false}}}/>
        <ColumnDirective headerText= 'Projected Meters' field= 'TotalProjectionPlannedQuantity' headerTextAlign='center' textAlign='right' width='150' allowEditing={false}   editType='numericedit' format={'N0'} edit={{ params:{ showSpinButton:false}}}/>
        <ColumnDirective headerText= 'Balance To Project Meters' field= 'BalanceProjectionPlanningQuantity' headerTextAlign='center' textAlign='right' width='150' allowEditing={false}   editType='numericedit' format={'N0'} edit={{ params:{ showSpinButton:false}}}/>
   
        <ColumnDirective headerText= 'Entry Date'  field= 'ProjectionPlanningDate' headerTextAlign='center' textAlign='right' width='140' allowEditing={true} type='date'  format={formatOptions} editType='datepickeredit'/>
        <ColumnDirective headerText= 'Fresh Planning Meters' field= 'ProjectionPlanningQuantity' headerTextAlign='center' textAlign='right' width='150' allowEditing={true}   editType='numericedit' format={'N0'} 
        editTemplate={(props)=>{
         return(
       <TextBoxComponent
           id={'ProjectionPlanningQuantity'}
           name={'ProjectionPlanningQuantity'}
           type='number'
           value={props.ProjectionPlanningQuantity}
           onChange={(e)=>{
             console.log(e.value)
             console.log(props)
             let finalBalanceToProjectMeters = props.BalanceProjectionPlanningQuantity -  e.value ;
             document.getElementById('ProjectionGridFinalBalanceToProjectMeters').value = finalBalanceToProjectMeters.toLocaleString();
             
            }}
            blur={(E)=>{
             let projectionPlanningDate =  document.getElementById('ProjectionGridProjectionPlanningDate').value 
            if(projectionPlanningDate){
              ProjectionGrid.endEdit()
            }else{
              alert('Please Enter Date')
              document.getElementById('ProjectionGridProjectionPlanningDate').focus() 
            }
           }}  
       />
         )
        }}/>
        <ColumnDirective headerText= 'Final Balance To Project Meters' field= 'FinalBalanceToProjectMeters' headerTextAlign='center' textAlign='right' width='150' allowEditing={false}  editType='numericedit' format={'n0'} edit={{ params:{ showSpinButton:false}}} />
         </ColumnsDirective>
      )
    }

    const belowprojectionGridColumns = ()=>{
      return(
        <ColumnsDirective>
        <ColumnDirective headerText= 'ID' field= 'FabricContractProjectionPlanningID' headerTextAlign='center' textAlign='left' width='90'/>
        <ColumnDirective headerText= 'Projection Planning Date' field= 'ProjectionPlanningDate' headerTextAlign='center' textAlign='right' width='120' allowEditing={false} type='date' format={formatOptions}/>
        <ColumnDirective headerText= 'Projection Planning Quantity' field= 'ProjectionPlanningQuantity' headerTextAlign='center' textAlign='right' width='150' allowEditing={false}   editType='numericedit' format={'N0'} edit={{ params:{ showSpinButton:false}}}/>
        <ColumnDirective headerText= 'Cancel' field= 'IsDeleted' headerTextAlign='center' textAlign='right' width='150'/>
        </ColumnsDirective>
      )
    }
    
  return (
    <div className='delivery-schedule-container'>
      <OrderDetails 
          ProjectionPlanningUpperData ={projectionPlanningUpperData}
        />
      <div>
      {showDialogs ?  
  <HardDelete
    {...deletingProps} 
    showResult={(e) => {
      console.log(e);
      setShowDialogs(false);
      if (e === false) {
        setShowDialogs(false);
        getProjectionDataSource();
        getProjectionPlanningUpperData(props.FabricContractID);
        getBelowProjectionData()
      }
    }} 
  />
: null}
        </div>
      <GridComponent
        ref={(grid) => (ProjectionGrid = grid)}
        id='ProjectionGrid'
        dataSource={projectionDataSource}
        editSettings={editSettings}
        toolbar={toolbarOptions}
        pageSettings={{ pageCount: 4, pageSizes: true, pageSize: 5 }}
        filterSettings={filterOptions}
        actionComplete={actionComplete}
        allowTextWrap='true'
        allowPaging={true}   
        allowSorting={true}
        allowFiltering={true}
        allowReordering={true}
        sortSettings={sortingOptions}
        rowSelected={
          (args)=>{
            if(selectedRows.length == 0){
            return selectedRows = args.data
          } }}
      >
        {projectionGridColumns()}
        <Inject
          services={[Edit, Toolbar, Page, Sort, Filter, Aggregate, Reorder, Resize]}
        />
            <AggregatesDirective>
  <AggregateDirective>
    <AggregateColumnsDirective>
        <AggregateColumnDirective
            field='ProjectionQuantity'
            type='Sum'
            footerTemplate={footerSum}
            />
        <AggregateColumnDirective
            field='TotalProjectionPlannedQuantity'
            type='Sum'
            footerTemplate={footerSum}
            />
        <AggregateColumnDirective
            field='BalanceProjectionPlanningQuantity'
            type='Sum'
            footerTemplate={footerSum}
            />
    </AggregateColumnsDirective>
</AggregateDirective>
</AggregatesDirective>
      </GridComponent>
      <br/>
      <GridComponent
        ref={(grid) => (belowProjectionGrid = grid)}
        id='belowProjectionGrid'
        dataSource={belowProjectionDataSource}
        editSettings={beloweditSettings}
        toolbar={belowtoolbarOptions}
        pageSettings={{ pageCount: 4, pageSizes: true, pageSize: 5 }}
        filterSettings={belowFilterOptions}
        allowTextWrap='true'
        allowPaging={true}   
        allowSorting={true}
        allowFiltering={true}
        allowReordering={true}
        sortSettings={belowsortingOptions}
        dataBound={databound}
        toolbarClick={toolbarClick}
        >
        {belowprojectionGridColumns()}
        <Inject
          services={[Edit, Toolbar, Page, Sort, Filter, Aggregate, Reorder, Resize]}
        />
            <AggregatesDirective>
  <AggregateDirective>
    <AggregateColumnsDirective>
        <AggregateColumnDirective
            field='ProjectionPlanningQuantity'
            type='Sum'
            footerTemplate={footerSum}
            />
        </AggregateColumnsDirective>
</AggregateDirective>
</AggregatesDirective>
      </GridComponent>
    </div>
  );
}
